// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2_wMs","clinicsSelect":"TableHeading_clinicsSelect__Qqs8U"};